import { Typography } from 'antd';
const { Paragraph, Text } = Typography;

const AccessibilityOptions = [
	{
		label: (
			<Paragraph style={{ fontSize: 14.5, margin: 0, lineHeight: 'normal' }}>
				Step free access
				<Text style={{ display: 'block', fontSize: 13 }}>
					Completely step free and wheelchair user friendly
				</Text>
			</Paragraph>
		),
		value: 'is_wheelchair_accessible'
	},
	{
		label: (
			<Paragraph style={{ fontSize: 14.5, margin: 0, lineHeight: 'normal' }}>
				Do not involve any escalator
			</Paragraph>
		),
		value: 'exclude_escalator'
	}
];

export default AccessibilityOptions;

// input onclick -> enable location selection in map
// while enabled, input can search for desired location